import { render } from "./SelecionarUsuarioAgrupadoPerfilModal.vue?vue&type=template&id=2b053d40&scoped=true&ts=true"
import script from "./SelecionarUsuarioAgrupadoPerfilModal.vue?vue&type=script&lang=ts"
export * from "./SelecionarUsuarioAgrupadoPerfilModal.vue?vue&type=script&lang=ts"

import "./SelecionarUsuarioAgrupadoPerfilModal.vue?vue&type=style&index=0&id=2b053d40&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b053d40"]])

export default __exports__